/**
 * This is a compiled JS file.
 * Changes here could be overwritten. 
 * Contact your Shopify developers if changes need to be made.
 */

$(document).ready(function () {
  //enable checkboxes after page load
  $("input[type='checkbox']").prop("disabled", false);

  //Scroll to top on page load
  $(window).on("beforeunload", function () {
    $(window).scrollTop(0);
  });

  //Show/Hide header tabs
  $(".tab").click(function () {
    $(".tab-content").removeClass("active-tab-content");
    $(".tab-content[data-id='" + $(this).attr("data-id") + "']").addClass(
      "active-tab-content"
    );
    $(".tab").removeClass("active-tab");
    $(this).parent().find(".tab").addClass("active-tab");
    //scroll up to top on switching tabs
    $("html, body").animate({ scrollTop: 0 }, 500, "swing");
  });

  //Sticky header on-scroll
  $(window).scroll(function (event) {
    var height = $(window).height();
    var header_height = $("#StickyHeaderWrap").height();
    var scroll = $(window).scrollTop();
    if (scroll > 130) {
      $(".sticky-header").addClass("stuck");
    }
    if (scroll > 250) {
      $(".sticky-header").addClass("show");
      $(".sticky-header").css({ top: header_height });
    } else {
      $(".sticky-header").removeClass("show");
      $(".sticky-header").removeClass("stuck");
    }
  });

  const totalTabs = $(".tab").length;
  let selectedProducts = {};
  let checkboxes = $("input[type='checkbox']");

  checkboxes.click(function () {
    let currProduct = $(this).attr("data-id");
    let currProductDataId = $(this).attr("data-id-products");
    let nextTab = null;
    let action = true; // Add or Remove item
    let currTabId = Number(currProductDataId.split("_")[1]);
    let selectionLimit = $('.tab-content[data-id="tab' + currTabId + '"]').attr(
      "data-product-limit"
    );
    $(this).parents(".product-info").find(".added_to_cart").addClass("hide");
    $(this).parents(".product-info").find(".product_counter").addClass("hide");
    if ($(this).is(":checked")) {
      $(this)
        .parents(".product-info")
        .find(".added_to_cart")
        .removeClass("hide");
      $(this)
        .parents(".product-info")
        .find(".product_counter")
        .removeClass("hide");
      let productTitle = $(this).val().split(" SKU:")[0];
      $(".Message_Bar").removeClass("is-hidden");
      $(".Message_Bar p span").text(productTitle);
      setTimeout(function () {
        $(".Message_Bar").addClass("is-hidden");
        $(".Message_Bar p span").text("");
      }, 2500);
    }
    let n = $("[data-id=tab" + currTabId + "] input:checked").length;
    //console.log(currTabId, selectionLimit);
    //console.log(n);
    if (n == selectionLimit) {
      $("[data-id=tab" + currTabId + "] input:not(:checked)").prop(
        "disabled",
        true
      );
    } else {
      action = false;
      $("[data-id=tab" + currTabId + "] input:not(:checked)").prop(
        "disabled",
        false
      );
    }

    //Show/Hide bubble counts and tick on completing selection limit
    if (n == selectionLimit) {
      $("#checkbox_count_" + currProductDataId).css("display", "inline-block");
      $("#checkbox_count_" + currProductDataId).html(
        `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" class="check-icon"><path d="M10.0007 15.1709L19.1931 5.97852L20.6073 7.39273L10.0007 17.9993L3.63672 11.6354L5.05093 10.2212L10.0007 15.1709Z" fill="rgba(255,255,255,1)"></path></svg>`
      );
    } else if (n > 0) {
      $("#checkbox_count_" + currProductDataId).css("display", "inline-block");
      $("#checkbox_count_" + currProductDataId).html(n);
    } else {
      $("#checkbox_count_" + currProductDataId).css("display", "none");
    }

    //Switching tabs after adding mandatory items
    if (action == true) {
      let nextTab = `tab${currTabId + 1}`;
      $(`.tab[data-id='${nextTab}']`).click();
      $("#searchbar").val("").trigger("keyup"); //clear search
      //scroll up to top on switching tabs
      $("html, body").animate({ scrollTop: 0 }, 500, "swing");
    }

    //Enabling submit btn if all mandatory products are selected
    if (
      $("#byob-form input[type=checkbox]:checked").length ==
      totalproductSelection
    ) {
      $("#submit-btn").prop("disabled", false);
    } else {
      $("#submit-btn").prop("disabled", true);
    }
  });

  //Disable inspect element Right click and F12 key
  $(document).bind("contextmenu", function (e) {
    e.preventDefault();
  });
  $(document).keydown(function (e) {
    if (e.which === 123) {
      return false;
    }
  });

  var addToCart = $("#submit-btn");

  // console.log(addToCart);

  addToCart.on("click", function (event) {
    // console.log("starting...");
    event.preventDefault();

    // Get the selected product variant ID and quantity
    var variantId = $(".product-single__variants option:selected").val();
    var quantity = 1;

    // console.log(variantId);

    // Get the checkboxes in the form
    var checkboxes = $("#byob-form").find(":input:checked");

    // Create an object to hold properties
    var properties = {};

    // Iterate through the checked checkboxes
    checkboxes.each(function (index) {
      // console.log("this is" + index);
      var checkboxValue = $(this).val();
      var checkboxName = $(this).attr("name");
      var checkboxPrice = $(this).data("price");

      if (checkboxValue !== "No") {
        // Add properties based on the checkbox values
        properties["_bundle_product" + (index + 1)] =
          checkboxValue.slice(-13) + "/" + 0 + "/" + quantity;
        // console.log(
        //   (properties["Item" + (index + 1)] =
        //     checkboxValue.slice(-13) + "/" + 0 + "/" + quantity)
        // );
      }
      // at last adding the main product details
      var mainSku = $(".product-single__variants option:selected").attr(
        "data-sku"
      );
      var mainProductPriceText = $(".prd-details .item-price").text().slice(8);
      var mainProductPrice = mainProductPriceText
        .slice(0, -2)
        .replace(/,/g, "");
      properties["_bundle_product6"] =
        mainSku + "/" + mainProductPrice + "/" + quantity;
      // console.log(
      //   (properties["_bundle_product4"] =
      //     mainSku + "/" + mainProductPrice + "/" + quantity)
      // );
      // console.log(mainProductPrice);
    });

    // Call the function to add the item to the cart with properties
    addItemToCart(variantId, quantity, properties);
  });

  function addItemToCart(variantId, quantity, properties) {
    // Define the data for the AJAX request
    var data = {
      quantity: quantity,
      id: variantId,
      properties: properties,
    };

    var ajax = {
      type: "POST",
      url: "/cart/add.js",
      data: data,
      dataType: "json",
      success: function (n) {
        var cart = new theme.CartDrawer();
        cart.init();
        cart.open();

        handleCartOperations();
      },
      error: function (n, c) {
        console.log("fail");
        // alert("failed!");
      },
    };
    jQuery.ajax(ajax);

    // Make the AJAX request to add the item to the cart
    // jQuery.ajax(ajax);
  }
}); //document.ready ends here
